import { useState } from "react";
import { Button } from "@/components/ui/button";
import { Popover, PopoverContent, PopoverTrigger } from "@/components/ui/popover";
import { Checkbox } from "@/components/ui/checkbox";
import { Filter } from "lucide-react";

// value: array of selected options; options: array of strings; onChange(newArray)
export default function MultiFilter({ label, options, value, onChange, testid }) {
  const [open, setOpen] = useState(false);
  const active = value.length > 0 && value.length < options.length;
  const toggle = (opt) => {
    if (value.includes(opt)) onChange(value.filter((v) => v !== opt));
    else onChange([...value, opt]);
  };
  return (
    <Popover open={open} onOpenChange={setOpen}>
      <PopoverTrigger asChild>
        <Button variant="ghost" size="icon" data-testid={testid}
          className={`h-6 w-6 ${active ? "text-primary" : "text-muted-foreground/60"}`}>
          <Filter className="h-3.5 w-3.5" fill={active ? "currentColor" : "none"} />
        </Button>
      </PopoverTrigger>
      <PopoverContent className="w-56 p-3" align="center">
        <div className="label-caps text-muted-foreground mb-2">{label}</div>
        <div className="flex gap-2 mb-2">
          <Button variant="outline" size="sm" className="h-7 text-xs flex-1" onClick={() => onChange([...options])} data-testid={`${testid}-all`}>Seleziona tutto</Button>
          <Button variant="outline" size="sm" className="h-7 text-xs flex-1" onClick={() => onChange([])} data-testid={`${testid}-none`}>Deseleziona</Button>
        </div>
        <div className="max-h-56 overflow-y-auto space-y-1.5">
          {options.map((opt) => (
            <label key={opt} className="flex items-center gap-2 text-sm cursor-pointer py-0.5">
              <Checkbox checked={value.includes(opt)} onCheckedChange={() => toggle(opt)} />
              <span className="truncate">{opt}</span>
            </label>
          ))}
        </div>
      </PopoverContent>
    </Popover>
  );
}
